import { gql } from '@apollo/client';

export const FEATURES = gql`
  query features {
    features {
      stressCheck
      regularHealthCheckup
    }
  }
`;

export interface FeaturesQueryResult {
  features: Features;
}

export interface Features {
  stressCheck: boolean;
  regularHealthCheckup: boolean;
}
